import React from 'react';
import { cn } from '@/lib/utils';

interface ProgressBarProps {
    current: number;
    total: number;
    showLabel?: boolean;
    className?: string;
}

export function ProgressBar({ current, total, showLabel = true, className }: ProgressBarProps) {
    const percentage = Math.min(100, Math.max(0, (current / total) * 100));

    return (
        <div className={cn("w-full", className)}>
            {showLabel && (
                <div className="flex justify-between text-xs text-muted-foreground mb-1">
                    <span>Progreso</span>
                    <span>{Math.round(percentage)}%</span>
                </div>
            )}
            <div className="h-2 w-full bg-secondary rounded-full overflow-hidden">
                <div
                    className="h-full bg-primary transition-all duration-500 ease-in-out rounded-full"
                    style={{ width: `${percentage}%` }}
                />
            </div>
        </div>
    );
}
